import authRequest from "@/api/http/authRequest";

const base = "/admin/alimtalk/send-requests";

export default {
  list(params, cb, err) { authRequest.get(base, params, cb, err) },
  detail(id, cb, err) { authRequest.get(`${base}/${id}`, {}, cb, err) },
  recipients(id, params, cb, err) { authRequest.get(`${base}/${id}/recipients`, params, cb, err) },
  exportRecipients(id, params, cb, err) { authRequest.excelDownload(`${base}/${id}/recipients/excel`, params, cb, err) },
  sync(id, cb, err) { authRequest.post(`${base}/${id}/sync`, {}, cb, err) },
}
